<template>
  <section class="card" id="card">
    <div class="content">
      <div class="left">
        <h1 class="title">
          <span class="light">¡BIENVENIDO AL </span>
          <span class="bold">FUTURO!</span>
        </h1>

        <ul class="list">
          <li>Puedes compartir tu información en segundos con solo acercar tu tarjeta al teléfono.</li>
          <li>Personalizar tu información como y cuando quieras.</li>
          <li>Personalizar la tarjeta con el color, logo y nombre que quieras.</li>
        </ul>
      </div>

      <div class="right">
        <video autoplay muted loop playsinline class="video">
          <source src="../assets/VIDEOS/blanco.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "tess" };
</script>

<style scoped>
@font-face {
  font-family: "TT Chocolates Trial";
  src: url("@/assets/fonts/TT Chocolates Trial Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.card {
  position: relative;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #050505;
  background-image: url("@/assets/IMG/NOSOTROS.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  margin: 0;
  padding: 0;
  border-radius: 0;
  scroll-margin-top: 55px;
}

.content {
  width: min(1200px, 92%);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(18px, 4vw, 80px);
  align-items: center;
  padding: 40px 0;
}

.title {
  color: #ffffff;
  font-family: "Exo", sans-serif;
  font-size: clamp(44px, 5.4vw, 78px);
  margin: 0 0 18px 0;
  line-height: 0.92;
}

.title .light {
  font-weight: 300;
  font-family: "Exo", sans-serif;
  font-size: 0.82em;
}

.title .bold {
  font-family: "TT Chocolates Trial", sans-serif;
  font-weight: 700;
  letter-spacing: 0.02em;
  font-size: 1.55em;
}

.list {
  margin: 0;
  padding-left: 18px;
  font-family: "Exo", sans-serif;
  color: #edf0f1;
  font-weight: 300;
  font-size: clamp(16px, 1.6vw, 24px);
  line-height: 1.55;
}

.list li {
  margin: 10px 0;
}

.right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.video {
  width: min(220px, 100%);
  height: 420px;
  border-radius: 18px;
  object-fit: cover;
  object-position: center;
  display: block;
  transform: translateZ(0);
  box-shadow: 0 20px 70px rgba(0, 0, 0, 0.45);
}

/* =========================================================
   iPad / Tablet (768–1024): 2 columnas pero más compacto
========================================================= */
@media (min-width: 768px) and (max-width: 1024px) {
  .card {
    min-height: auto;
    padding: 30px 0;
  }

  .content {
    width: min(980px, 92%);
    gap: 36px;
    padding: 24px 0;
  }

  .title {
    font-size: clamp(40px, 5.2vw, 64px);
    margin-bottom: 14px;
  }

  .list {
    font-size: clamp(16px, 2vw, 20px);
  }

  .video {
    width: 210px;
    height: 390px;
  }
}

/* =========================================================
   Celular (<= 767): 1 columna y tamaños consistentes
========================================================= */
@media (max-width: 767px) {
  .card {
    min-height: auto;
    padding: 26px 0 34px;
  }

  .content {
    grid-template-columns: 1fr;
    text-align: center;
    width: min(980px, 94%);
    padding: 10px 0 0;
    gap: 18px;
  }

  .title {
    font-size: clamp(34px, 9.5vw, 54px);
    line-height: 0.95;
    margin-bottom: 12px;
  }

  .title .bold {
    font-size: 1.45em;
  }

  .list {
    text-align: left;
    margin: 0 auto;
    max-width: 520px;
    font-size: clamp(15px, 4.2vw, 18px);
    line-height: 1.55;
  }

  .right {
    margin-top: 6px;
  }

  .video {
    width: min(240px, 78vw);
    height: min(460px, 72vh);
    object-fit: contain;
    border-radius: 18px;
  }
}

@media (max-width: 420px) {
  .card {
    padding: 18px 0 28px;
  }

  .title {
    font-size: clamp(30px, 10vw, 46px);
  }

  .video {
    width: min(230px, 82vw);
    height: min(420px, 66vh);
  }
}
</style>
